import { render, staticRenderFns } from "./to-forever.vue?vue&type=template&id=180341ce&lang=pug&"
import script from "./to-forever.vue?vue&type=script&lang=js&"
export * from "./to-forever.vue?vue&type=script&lang=js&"
import style0 from "./to-forever.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.5_snackhrvn2skq2fk5zrw2w5ryi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cj/Documents/Work/the-wedding/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('180341ce')) {
      api.createRecord('180341ce', component.options)
    } else {
      api.reload('180341ce', component.options)
    }
    module.hot.accept("./to-forever.vue?vue&type=template&id=180341ce&lang=pug&", function () {
      api.rerender('180341ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/to-forever.vue"
export default component.exports